module.exports = __webpack_public_path__ + "static/letreiro-ba79cb2087760362d4b90b1f009923da.jpg";